import useApiWorker from 'hooks/useApiWorker';
import { DataCertification, DataCertificationIdentifier } from '../types/data-certification';

const defaultErrorResponse: ApiResponse<DataCertification> = {
  success: false,
  message: 'An error occurred',
};

export async function ListDataCertifications(): Promise<ApiListResponse<DataCertificationIdentifier>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .get<Array<DataCertificationIdentifier>>(`/datacertifications`)
    .then((result) => {
      return {
        success: true,
        data: result.data.map((dci) => {
          if (dci.SchoolId) {
            dci.Name = `School: ${dci.DistrictId}-${dci.SchoolId}`;
          } else {
            dci.Name = `District: ${dci.DistrictId}`;
          }
          return dci;
        }),
      };
    })
    .catch((error) => {
      return {
        success: false,
        message: error.response.data.message,
      };
    });
}

export async function GetDataCertification(queryParams?: string): Promise<ApiResponse<DataCertification>> {
  const apiWorker = useApiWorker();
  if (!queryParams) queryParams = '';
  queryParams = queryParams.replace(/&$/, '');
  const path = `/datacertification?` + queryParams;
  return apiWorker
    .get<DataCertification>(path)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      if (error.response.status === 404) {
        return {
          success: false,
          message: 'Data has never been certified.',
        };
      }
      return {
        success: false,
        message: error.response.data.message,
      };
    });
}

export async function CertifyData(queryParams?: string): Promise<ApiResponse<DataCertification>> {
  const apiWorker = useApiWorker();

  if (!queryParams) queryParams = '';
  queryParams = queryParams.replace(/&$/, '');
  const path = `datacertifications/certify?` + queryParams;
  
  return apiWorker
    .post<DataCertification>(path)
    .then(() => {
      return { success: true };
    })
    .catch((error) => {
      return {
        errors: error.response.data,
        ...defaultErrorResponse,
      };
    });
}

export async function UncertifyData(queryParams?: string): Promise<ApiResponse<DataCertification>> {
  const apiWorker = useApiWorker();

  if (!queryParams) queryParams = '';
  queryParams = queryParams.replace(/&$/, '');
  const path = `datacertifications/uncertify?` + queryParams;

  return apiWorker
    .post<DataCertification>(path)
    .then(() => {
      return { success: true };
    })
    .catch((error) => {
      return {
        errors: error.response.data,
        ...defaultErrorResponse,
      };
    });
}

export async function DeleteDataCertification(dataCertificationId: string): Promise<ApiResponse<DataCertification>> {
  const apiWorker = useApiWorker();

  return apiWorker
    .delete(`/datacertifications/${dataCertificationId}`)
    .then(() => {
      return { success: true };
    })
    .catch((error) => {
      return { success: false, message: error.response.data };
    });
}
